import DFGrid from "app/widgets/DFGrid/DFGrid";
if (!kendo.data.binders.widget.dfgrid) {
    kendo.data.binders.widget.dfgrid = {};
}
kendo.data.binders.widget.basicgrid = kendo.data.binders.widget.dfgrid;

const BasicGrid = DFGrid.extend({

    options: {
        name: "BasicGrid",
        navigatable: true
    },

    spaceKey: function(data) {
        this.triggerDetailRow(data);
        this.triggerGroupAction(data);
        return true;
    },

    enterKey: function(data) {
        this.triggerEditAction(data);
        this.triggerGroupToggle(data);
        this.triggerCellAction(data);
        return true;
    }
});
kendo.ui.plugin(BasicGrid);
export default BasicGrid;
